import { jsx as _jsx } from "react/jsx-runtime";
import LoadingContent from "../../components/LoadingContent/LoadingContent";
import { useHandleAwsSignIn } from "../../hooks/useHandleAwsSingIn";
import { useAccountValidation } from "../../hooks/useAWSAccountValidation";
const HandleAwsSignIn = () => {
    const { awsAccountId } = useHandleAwsSignIn();
    useAccountValidation(awsAccountId);
    return _jsx(LoadingContent, { text: "Loading" });
};
export default HandleAwsSignIn;
